import { useMemo } from 'react';
import useTokensInitialData from '../queries/useTokenInitialData';
import { useAppSelector } from '../index';
import { selectBridgeSlice } from '../../redux/slices/bridgeSlice';

const useToChainTokenFee = () => {
  const tokensInitialData = useTokensInitialData();
  const { toChainToken } = useAppSelector(selectBridgeSlice);

  const toChainTokenFee = useMemo(() => {
    if (!tokensInitialData || !toChainToken) return null;

    return (
      tokensInitialData.find((token) => token.symbol === toChainToken.symbol) ??
      null
    );
  }, [tokensInitialData, toChainToken]);

  return toChainTokenFee ?? null;
};

export default useToChainTokenFee;
